module.exports = __webpack_public_path__ + "static/teaser-2bab9769823b9f1d6a83849bb15b73d9.png";